export { default } from './Typography';
export { Text } from './Typography.styled';
